<template>
  <svg width="1em" height="1em" viewBox="0 0 24 24"><path fill="currentColor" d="M18 8h2a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h2V7a6 6 0 1 1 12 0v1zm-2 0V7a4 4 0 1 0-8 0v1h8zm-9 3v2h2v-2H7zm0 3v2h2v-2H7zm0 3v2h2v-2H7z"></path></svg>
</template>

<script>
export default {
  name: 'RiGitRepositoryPrivateFill'
}
</script>